import React from 'react';

interface DividerIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const DividerIcon: React.FC<DividerIconProps> = ({ 
  width = 2, 
  height = 28, 
  color = '#BABABA',
  className,
  style 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox="0 0 2 28"
      fill="none"
      className={className}
      style={style}
    >
      <path 
        d="M0.699951 0L0.69995 28" 
        stroke={color} 
        strokeWidth="1.4"
      />
    </svg>
  );
};

export default DividerIcon;


